const addDocumentStyle = {
  width: '100%',
  margin: '5px',
  padding: '5px',
  backgroundColor: '#5ab85a',
};
const removeDocumentStyle = {
  width: '100%',
  margin: '5px',
  padding: '5px',
  backgroundColor: '#e0e0e0',
  color: '#da291c',
  fontWeight: '900',
};

const troubleProtocolActionsWithNote = {
  actionTakenWithNote: 'actionTaken5',
  circumstanceWithNote: 'circumstance06',
  failedActionWithNote: 'failedAction3',
};

const installationProtocolActionsWithNote = {
  failedActionWithNote: 'failedAction05',
};

const ticketTypesForInstallationProtocol = [
  2,
  10,
  11,
  12,
  13,
  14,
  24,
  33,
  38,
  40,
  43,
  44,
  68,
  71,
  2,
  10,
  11,
  12,
  13,
  14,
  24,
  33,
  38,
  40,
  43,
  44,
  68,
  71,
];
const ticketTypesForTroubleProtocol = [1, 36, 37, 72];
export const ticketTypesInstallation = [
  2,
  10,
  11,
  12,
  13,
  14,
  15,
  17,
  19,
  24,
  25,
  32,
  33,
  34,
  38,
  40,
  43,
  44,
  45,
  47,
  49,
  50,
  51,
  53,
  54,
  68,
  71,
  73,
  76,
  77,
  79,
  80,
];

export {
  addDocumentStyle,
  removeDocumentStyle,
  troubleProtocolActionsWithNote,
  installationProtocolActionsWithNote,
  ticketTypesForInstallationProtocol,
  ticketTypesForTroubleProtocol,
};
